(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lottie"] && !Shopify.designMode) return;
  try {
    class LottieBlock extends HTMLElement {
    constructor() {
      super();
      this.player = this.querySelector('lottie-player');
      this.observer = null;
      this.hasPlayed = false;
    }

    connectedCallback() {
      if (!this.player) return;

      const autoplayViewport = this.player.dataset.autoplayViewport === 'true';

      if (autoplayViewport) {
        this.initIntersectionObserver();
      } else {
        // Play immediately if not viewport-triggered
        this.playAnimation();
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    initIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1, // Trigger when 10% of the element is visible
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasPlayed) {
            this.playAnimation();
            this.hasPlayed = true;
          }
        });
      }, options);

      this.observer.observe(this);
    }

    playAnimation() {
      if (this.player && typeof this.player.play === 'function') {
        this.player.play();
      }
    }
  }

  if (!customElements.get('lottie-block')) {
    customElements.define('lottie-block', LottieBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    class TabsComponent extends HTMLElement {
    constructor() {
      super();
      this.tablist = this.querySelector('[data-tabs-list]');
      this.tabs = Array.from(this.querySelectorAll('[data-tab-button]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      this.init();
    }

    init() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', (e) => this.handleKeyDown(e, tab));
      });
    }

    selectTab(selectedTab) {
      const selectedIndex = parseInt(selectedTab.dataset.tabIndex);

      this.tabs.forEach((tab, index) => {
        const isSelected = index === selectedIndex;
        tab.setAttribute('aria-selected', isSelected);
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      this.panels.forEach((panel, index) => {
        const isSelected = index === selectedIndex;
        panel.hidden = !isSelected;
      });

      selectedTab.focus();
    }

    handleKeyDown(event, currentTab) {
      const currentIndex = this.tabs.indexOf(currentTab);
      let targetIndex = currentIndex;

      switch (event.key) {
        case 'ArrowRight':
          event.preventDefault();
          targetIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'ArrowLeft':
          event.preventDefault();
          targetIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          event.preventDefault();
          targetIndex = 0;
          break;
        case 'End':
          event.preventDefault();
          targetIndex = this.tabs.length - 1;
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.selectTab(currentTab);
          return;
        default:
          return;
      }

      this.selectTab(this.tabs[targetIndex]);
    }
  }

  if (!customElements.get('tabs-component')) {
    customElements.define('tabs-component', TabsComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
